import { useCallback, useEffect, useState } from "react";
import { CalMeResponse } from "@/types/calendar";
import { useCalApi } from "./useCalApi";

type UseCalMeResult = {
  isLoading: boolean;
  data: CalMeResponse | null;
  refetch: () => Promise<void>;
};

/**
 * Hook to fetch the current user's Cal.com profile.
 * Replaces @calcom/atoms useMe hook.
 */
export function useCalMe(): UseCalMeResult {
  const { fetchCalApi } = useCalApi();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<CalMeResponse | null>(null);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await fetchCalApi<CalMeResponse>("/me");
      setData(result);
    } finally {
      setIsLoading(false);
    }
  }, [fetchCalApi]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    isLoading,
    data,
    refetch: fetchData,
  };
}
